import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import transduce from './transduce';

/**
 * @param {function} xform
 * @param {any} coll
 * @returns {Object}
 */
function toObject(xform, coll) {
  return transduce(xform, function (result, x) {
    return _extends({}, result, Array.isArray(x) ? _defineProperty({}, x[0], x[1]) : x);
  }, {}, coll);
}

export default toObject;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/fp/toObject.js
// module id = 699
// module chunks = 0